import React, { Component } from 'react'
import { Input, Button, Popover } from 'hljd'
import { Upload } from 'hlj-components'
import { inject, observer } from 'mobx-react'
import Style from './style.module.less'

const TextArea = Input.TextArea

@inject('store')
@observer
export default class extends Component {
  state = {
    link: ''
  }

  render() {
    const {
      store: { deleteShareImage, editShareImage, shareImage, chatStore }
    } = this.props
    let { changeLiveNotice, liveNotice, submitLiveNotice } = chatStore
    liveNotice = liveNotice || ''
    return (
      <div className={Style.tool}>
        <div className={Style['tool-group']}>
          <p className={`${Style.title}`} style={{ marginRight: '30px' }}>
            直播公告
          </p>
          <div className={Style['input-group']}>
            <TextArea
              rows={5}
              maxLength={30}
              placeholder="点击【右下角预约】抢直播福利！"
              value={liveNotice}
              onChange={changeLiveNotice}
            />

            <p className={Style.bottom}>
              <span className={Style.num}>{liveNotice.length}/30</span>
              <Button type="primary" onClick={submitLiveNotice}>
                提交
              </Button>
            </p>
          </div>
        </div>
        <div className={Style['tool-group']}>
          <p className={`${Style.title}`} style={{ marginRight: '30px' }}>
            分享配图
          </p>
          <div className={Style['upload-group']}>
            <Upload
              width={200}
              height={150}
              aspect={5 / 4}
              link={shareImage}
              onDelete={deleteShareImage}
              autoSizeError={true}
              showDelete={true}
              clipabled
              max_file_size="10mb"
              onCliped={editShareImage}
              description={
                <div>
                  <p>上传图片</p>
                  <p>600*480</p>
                </div>
              }
              filters={{
                mime_types: [
                  {
                    title: 'images files',
                    extensions: 'jpg,gif,png,jpeg,bmp'
                  }
                ],
                max_file_size: '10mb',
                prevent_duplicates: true
              }}
            />
            <div className={Style.desc}>
              <div>微信、微博等第三方渠道分享配图</div>
              <div>图片要求：</div>
              <div>
                1.&ensp;&thinsp;图片大小不可大于<span>10M</span>，需<span>
                  高清
                </span>，可参考
                <Popover
                  content={
                    <img src="https://qnm.hunliji.com/o_1dagc6vb51sp0adaqe53sv1l3h9.jpg" />
                  }
                  title="样例"
                >
                  <span style={{ cursor: 'pointer', color: '#FF801A' }}>
                    样例
                  </span>
                </Popover>；
              </div>
              <div>
                2.&ensp;宽高比5：4，支持<span>JPG、PNG</span>等大部分格式；
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
